module.exports = __webpack_public_path__ + "img/21.f9defad1.png";